export enum TypeFilterClientEnum {
    SELECTION = 'Seleção',
    TO_OMIT = 'Omitir',
    WEB_ONLY = 'Migrados',
    LEGACY_ONLY = 'Não migrados',
    ALL = 'Todos',
}

export type TypeFilterClient = 'SELECTION' | 'TO_OMIT' | 'WEB_ONLY' | 'LEGACY_ONLY' | 'ALL';
